// extracted by mini-css-extract-plugin
export default {"departments":"hI-z","departmentHeading":"iI-z","departmentSection":"jI-z","departmentName":"kI-z","departmentLink":"lI-z","expandIcon":"mI-z"};